export default async function GetSplitsTreeApi(id) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/${id}/splits-tree`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
        console.log(response);
      })
      .catch((error) => {
        console.error("Error: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }
  return res;
}
